module.exports = __webpack_public_path__ + "img/icon_heart.db2d854e.svg";